import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
    'rounded-full text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
    {
        variants: {
            variant: {
                default: 'bg-primary text-white',
                // hover:bg-destructive/90 never worked: Tailwind can't apply opacity modifiers
                // to CSS-variable-backed theme colors in this build (no color-mix() support here),
                // so opacity is applied to the whole button instead.
                destructive: 'bg-destructive text-destructive-foreground hover:opacity-90',
                outline: 'border border-input bg-background hover:bg-accent',
                tertiary: 'border border-input bg-accent hover:bg-gray',
                secondary: 'bg-electric-lime text-secondary-foreground hover:bg-pear',
                ghost: 'border md:border-0 hover:bg-accent',
                link: 'text-primary underline-offset-4 hover:underline',
            },
            size: {
                default: 'px-6 py-2 h-10',
                sm: 'rounded-full px-3 py-1.5',
                lg: 'rounded-full px-8 py-2.5',
                xlg: 'rounded-full px-16 py-2.5',
                icon: 'h-10 w-10',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    },
)
